export default "__VITE_ASSET__1BAKXMKF__"